export const CONFIG = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL.replace(/\/$/, ''),
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN_URL,
  DEPLOYMENT_TIME: import.meta.env.VITE_DEPLOYMENT_TIME,
  FRONTEND_VERSION: import.meta.env.FRONTEND_VERSION,
  ANALYTICS_ENABLED: window.location.hostname !== 'localhost',
}

if (!CONFIG.API_BASE_URL.startsWith('https://') && !CONFIG.API_BASE_URL.startsWith('http://')) {
  CONFIG.API_BASE_URL = 'https://' + CONFIG.API_BASE_URL
}

if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
  console.log('DEPLOYMENT_TIME', CONFIG.DEPLOYMENT_TIME)
}

(window as any).CONFIG = CONFIG //will help to debug
